module.exports = __webpack_public_path__ + "img/bitmoji_group.dab081b3.png";